import { CallToActionView, View, OddsGalleryView, PagerView, ProgressImagePathView, TextView, OddsFrameView,
         MatchdayAreaModel, MatchdaypickerView } from "@gaming/srvg-classes-core";

export class MatchdayArea extends View{
    matchdayPicker: MatchdaypickerView;
    calltoactionView: CallToActionView;
    oddsGallery: OddsGalleryView;
    oddsPager: PagerView;
    oddsFrame: OddsFrameView;
    selector: string;
    matchdayAreaModel: MatchdayAreaModel;

    constructor(options){
        options = options || {};
        super(options);
        this.selector = options.selector || '#matchday_area';
        this.matchdayAreaModel = new MatchdayAreaModel( { offset: options.offset || 0 } );

        var suffix = '';
        var res = this.selector.match( '([0-9]+)$' );
        if( res && res.length ) {
            suffix = '_'+res[0];
        }
        this.name = 'matchdayArea'+suffix;

        /******************* initialize views ************************/

        if( options.hasMatchdayPicker ) {
            this.matchdayPicker = this.addSubView( new MatchdaypickerView( { selector: '#match_day_picker' } ) );
        }
        else {
            this.matchdayPicker = null;
        }

        options.clock = options.clock || {};

        if( srvg.screenName=='wide' ) {
            var progressViewOptions = new ProgressImagePathView({
                selector: '#progressview' + suffix,
                width: 108,
                height: 44,
                background: srvg.url.image + 'call_to_action/cta-clock-gradient_wide.png',
                pathwidth: 6,
                path: [
                    {x: 52, y: 4}, {x: 92, y: 4}, {x: 103, y: 22}, {x: 92, y: 40},
                    {x: 4, y: 40}, {x: 4, y: 4}, {x: 52, y: 4}
                ]
            });
        }else {
            var progressViewOptions = new ProgressImagePathView({
                selector: '#progressview'+suffix,
                width: 150,
                height: 68,
                background: srvg.url.image+'call_to_action/cta-clock-gradient.png',
                pathwidth: 6,
                path: [ { x: 75, y:11 }, { x: 122, y:11 }, { x: 137, y:34 }, { x: 122, y:57 },
                    { x: 11, y:57 }, { x: 11, y:11 }, { x: 75, y:11 }
                ]
            });
        }

        var callToActionViewOptions = {
            selector: '#calltoaction'+suffix,
            name:'calltoactionView'+suffix,
            clock: {
                selector: '#clock'+suffix,
                name: 'clockview'+suffix,
                // has extended layout with spans etc for other layouts needed, for example collapsed view
                layout: options.clock.layout || null,
                hourLayout: options.clock.hourLayout || null
            },
            progressView: progressViewOptions,
            lockView: new View( { selector: '#lock'+suffix } ),
            logoView: new TextView( { selector: '#product_logo'+suffix } ),
            textView: new TextView( { selector: '#calltoaction_text'+suffix } ),
            seasonView: null,
            seasonNrView: null,
            matchdayView: null,
            matchdayNrView: null
        };

        if( options.hasInteractiveCallToAction ) {
            callToActionViewOptions.seasonView = new TextView( { selector: '#season' + suffix } );
            callToActionViewOptions.seasonNrView = new TextView( { selector: '#season_nr' + suffix } );
            callToActionViewOptions.matchdayView = new TextView( { selector: '#matchday' + suffix } );
            callToActionViewOptions.matchdayNrView = new TextView( { selector: '#matchday_nr' + suffix } );
        }
        this.calltoactionView = this.addSubView( new CallToActionView( callToActionViewOptions ) );
        this.oddsPager = null; //this.addSubView( new SrvgPager( { selector: '#pager'+suffix } ) );
        if( options.hasOddsGallery && !srvg.featuresInstances.getDisableComboButton() ) {
            var oddsGalleryOptions = options.oddsGallery,
                defaultGalleryOptions = {
                    selector: '#oddsview'+suffix,
                    displayTime: 15,
                    numberOfItemsToShow: 3
                };
            oddsGalleryOptions = this.mergeOptions(defaultGalleryOptions, oddsGalleryOptions);

            this.oddsGallery = this.addSubView( new OddsGalleryView( oddsGalleryOptions ) );
        }
        else {
            this.oddsGallery = null;
        }

        if( options.hasOddsFrame ) {
            this.oddsFrame = this.addSubView( new OddsFrameView( { selector: '#currentCustomerIframe'+suffix, name:'oddsFrame'+suffix } ) );
        }
        else {
            this.oddsFrame = null;
        }
    }
}